module.exports = __webpack_public_path__ + "media/images/admin/icons/phone-call-6a95923bc361c1552d856d03b4c6c44d.svg";